import { KinematicsGraph, ProjectionFootPlantGraph } from '@/pages/ReportV2/components/Graphs';

interface RunReportChartProps {
  PDFDownloadData: any;
  ChartComponentRefs: any;
}

export const RunReportCharts = ({ PDFDownloadData, ChartComponentRefs: ChartComponentRefs }: RunReportChartProps) => {
  return (
    <div style={{ display: 'none' }}>
      <ProjectionFootPlantGraph
        data={PDFDownloadData.footplantAtInitialContactSeries_Left}
        forPdf={true}
        ref={ChartComponentRefs['footplantAtInitialContact_Left']}
        subtitle='Initial Contact'
      />
      <ProjectionFootPlantGraph
        data={PDFDownloadData.footplantAtMidStanceSeries_Left}
        forPdf={true}
        ref={ChartComponentRefs['footplantAtMidStance_Left']}
        subtitle='MidStance'
      />
      <ProjectionFootPlantGraph
        data={PDFDownloadData.footplantAtHeelOffSeries_Left}
        forPdf={true}
        ref={ChartComponentRefs['footplantAtHeelOff_Left']}
        subtitle='Heel Off'
      />
      <ProjectionFootPlantGraph
        data={PDFDownloadData.footplantAtInitialContactSeries_Right}
        forPdf={true}
        ref={ChartComponentRefs['footplantAtInitialContact_Right']}
        subtitle='Initial Contact'
      />
      <ProjectionFootPlantGraph
        data={PDFDownloadData.footplantAtMidStanceSeries_Right}
        forPdf={true}
        ref={ChartComponentRefs['footplantAtMidStance_Right']}
        subtitle='MidStance'
      />
      <ProjectionFootPlantGraph
        data={PDFDownloadData.footplantAtHeelOffSeries_Right}
        forPdf={true}
        ref={ChartComponentRefs['footplantAtHeelOff_Right']}
        subtitle='Heel Off'
      />
      <KinematicsGraph
        data={PDFDownloadData.pelvisKinematicData.Sagittal.series}
        forPdf={true}
        graphAnnotations={PDFDownloadData.graphAnnotations}
        ref={ChartComponentRefs['pelvisKinematicSagittal']}
        strokeWidth={2}
        subtitle={'Anterior tilt (-) / Posterior tilt (+)'}
        title={'Sagittal'}
        yAxis={PDFDownloadData.pelvisKinematicData.Sagittal.yAxis}
      />
      <KinematicsGraph
        data={PDFDownloadData.pelvisKinematicData.Coronal.series}
        forPdf={true}
        graphAnnotations={PDFDownloadData.graphAnnotations}
        ref={ChartComponentRefs['pelvisKinematicCoronal']}
        strokeWidth={2}
        subtitle={'Drop (-) / Hike (+)'}
        title={'Frontal'}
        yAxis={PDFDownloadData.pelvisKinematicData.Coronal.yAxis}
      />
      <KinematicsGraph
        data={PDFDownloadData.pelvisKinematicData.Transversal.series}
        forPdf={true}
        graphAnnotations={PDFDownloadData.graphAnnotations}
        ref={ChartComponentRefs['pelvisKinematicTransversal']}
        strokeWidth={2}
        subtitle={'Backward Rotation (-) / Forward Rotation (+)'}
        title={'Transversal'}
        yAxis={PDFDownloadData.pelvisKinematicData.Transversal.yAxis}
      />
      <KinematicsGraph
        data={PDFDownloadData.hipKinematicData.Sagittal.series}
        forPdf={true}
        graphAnnotations={PDFDownloadData.graphAnnotations}
        ref={ChartComponentRefs['hipKinematicSagittal']}
        strokeWidth={2}
        subtitle={'Extension (-) / Flexion (+)'}
        title={'Sagittal'}
        yAxis={PDFDownloadData.hipKinematicData.Sagittal.yAxis}
      />
      <KinematicsGraph
        data={PDFDownloadData.hipKinematicData.Coronal.series}
        forPdf={true}
        graphAnnotations={PDFDownloadData.graphAnnotations}
        ref={ChartComponentRefs['hipKinematicCoronal']}
        strokeWidth={2}
        subtitle={'Abduction (-) / Adduction (+)'}
        title={'Frontal'}
        yAxis={PDFDownloadData.hipKinematicData.Coronal.yAxis}
      />
      <KinematicsGraph
        data={PDFDownloadData.hipKinematicData.Transversal.series}
        forPdf={true}
        graphAnnotations={PDFDownloadData.graphAnnotations}
        ref={ChartComponentRefs['hipKinematicTransversal']}
        strokeWidth={2}
        subtitle={'External Rotation (-) / Internal Rotation (+)'}
        title={'Transversal'}
        yAxis={PDFDownloadData.hipKinematicData.Transversal.yAxis}
      />
      <KinematicsGraph
        data={PDFDownloadData.kneeKinematicData.Sagittal.series}
        forPdf={true}
        graphAnnotations={PDFDownloadData.graphAnnotations}
        ref={ChartComponentRefs['kneeKinematicSagittal']}
        strokeWidth={2}
        subtitle={'Extension (-) / Flexion (+)'}
        title={'Sagittal'}
        yAxis={PDFDownloadData.kneeKinematicData.Sagittal.yAxis}
      />
      <KinematicsGraph
        data={PDFDownloadData.kneeKinematicData.Coronal.series}
        forPdf={true}
        graphAnnotations={PDFDownloadData.graphAnnotations}
        ref={ChartComponentRefs['kneeKinematicCoronal']}
        strokeWidth={2}
        subtitle={'Valgus (-) / Varus (+)'}
        title={'Frontal'}
        yAxis={PDFDownloadData.kneeKinematicData.Coronal.yAxis}
      />
      <KinematicsGraph
        data={PDFDownloadData.kneeKinematicData.Transversal.series}
        forPdf={true}
        graphAnnotations={PDFDownloadData.graphAnnotations}
        ref={ChartComponentRefs['kneeKinematicTransversal']}
        strokeWidth={2}
        subtitle={'External Rotation (-) / Internal Rotation (+)'}
        title={'Transversal'}
        yAxis={PDFDownloadData.kneeKinematicData.Transversal.yAxis}
      />
      <KinematicsGraph
        data={PDFDownloadData.ankleKinematicData.Sagittal.series}
        forPdf={true}
        graphAnnotations={PDFDownloadData.graphAnnotations}
        ref={ChartComponentRefs['ankleKinematicSagittal']}
        strokeWidth={2}
        subtitle={'Plantarflexion (-) / Dorsalflexion (+)'}
        title={'Sagittal'}
        yAxis={PDFDownloadData.ankleKinematicData.Sagittal.yAxis}
      />
      <KinematicsGraph
        data={PDFDownloadData.ankleKinematicData.Coronal.series}
        forPdf={true}
        graphAnnotations={PDFDownloadData.graphAnnotations}
        ref={ChartComponentRefs['ankleKinematicCoronal']}
        strokeWidth={2}
        subtitle={'Eversion (-) / Inversion (+)'}
        title={'Frontal'}
        yAxis={PDFDownloadData.ankleKinematicData.Coronal.yAxis}
      />
      <KinematicsGraph
        data={PDFDownloadData.ankleKinematicData.Transversal.series}
        forPdf={true}
        graphAnnotations={PDFDownloadData.graphAnnotations}
        ref={ChartComponentRefs['ankleKinematicTransversal']}
        strokeWidth={2}
        subtitle={'External Rotation (-) / Internal Rotation (+)'}
        title={'Transversal'}
        yAxis={PDFDownloadData.ankleKinematicData.Transversal.yAxis}
      />
    </div>
  );
};
